import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.625 9.755a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m0 0h-.375m-13.5 3.009c0 1.601 1.123 2.995 2.707 3.228q1.63.24 3.293.368v4.645l4.184-4.184c.206-.207.485-.324.778-.331a48 48 0 0 0 5.83-.498c1.585-.233 2.708-1.627 2.708-3.228V6.745c0-1.6-1.123-2.995-2.707-3.227A48.4 48.4 0 0 0 12 3.005c-2.392 0-4.744.175-7.043.513C3.373 3.75 2.25 5.144 2.25 6.745z"
    }, null, -1)
  ])))
}
export default { render: render }